import * as React from 'react'

import useScreenSizeStyle from '../hooks/useScreenSizeStyle'
import Icons from '../ui/Icons'
import { ZentakeContext } from '../utils/ZentakeContext'

function OfflineBanner() {
  const { isOnline } = React.useContext(ZentakeContext)
  const iconSize = useScreenSizeStyle({ generic: 4, md: 5 })

  if (isOnline) return null
  return (
    <div className="w-full bg-gray-200 space-x-2 flex p-2 justify-center items-center border-b">
      <Icons.StatusOffline size={iconSize} />
      <span className="text-xs md:text-sm font-medium">
        You are on offline mode
      </span>
    </div>
  )
}

export default OfflineBanner
